import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

import Vas from '../../../Vas';

import '../../../css/CustomerPaymentDetails.css';
import { DateTimeHelper } from 'utils-lib';

import { TextField,MessageBox,Checkbox } from 'component-lib';

import { PaymentsModel, RequestAjaxClass} from 'models-lib';

var moment = require('moment');
moment().format();

class CustomerContractDetails extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.reference=this;
        this.from = '';
        this.to ='';
        this.load();

        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.PaymentsModel = new PaymentsModel([this],null,this.Request);
    }
    
    componentWillMount(){
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setAuth(true);
      this.Request.setErrorHandler((data)=>{
        ReactDOM.render(<MessageBox
          AppURL={Vas.ApplicationUrl}
          Title={Vas.Resources.Labels["DefaultPayment"]}
          Message={data.Description} /> , document.getElementById('messageContainer'));
        ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
      });
  }

  componentDidMount(){
    document.getElementById("Pay").checked = this.props.data[0].IsDefaultPaymentMethod !== '' ? true : false;

    this.LogoClick();

    this.FontSizeClick();
  }

  Update(observer)
    {
        this.setState({},()=>{
          if(observer === "StandartPaymentsOption"){
            let referenc = this.props.reference;
            let table = this.props.table;
            localStorage.setItem('vas_refresh', "Payment");
            if (this.PaymentsModel.PaymentOption.IsDefaultPaymentMethod === true){
                ReactDOM.render(<MessageBox
                  AppURL={Vas.ApplicationUrl}
                  Title={Vas.Resources.Labels["DefaultPayment"]}
                  Message={Vas.Resources.Labels["DefaultPaymentChanged"]} /> , document.getElementById('messageContainer'));
            } else {
                ReactDOM.render(<MessageBox
                  AppURL={Vas.ApplicationUrl}
                  Title={Vas.Resources.Labels["DefaultPayment"]}
                  Message={Vas.Resources.Labels["DefaultPaymentNotChanged"]} /> , document.getElementById('messageContainer'));
            }
            referenc.load(table.PrepareSendData()); 
            $("#LoadingIcon").removeClass().addClass('loaderSmall');
            ReactDOM.render(Vas.Resources.Labels["NoPayments"], document.getElementById('paymentDetails'));
          }
        });
    }

    load(){
        if (this.props.data[0].ValidFrom){
            this.from = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.props.data[0].ValidFrom,false,localStorage.getItem('vas_language'))); 
        }

        if (this.props.data[0].ValidTo){
            this.to = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.props.data[0].ValidTo,false,localStorage.getItem('vas_language')));
        }
    }

    SetDefaultPayment(){
      if (this.refs.defaultPayment){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        let newValue = document.getElementById("Pay").checked;
        
        let curFrom = null;
        if(this.props.data[0].ValidFrom){
          if (this.props.data[0].ValidFrom.length > 0){
            let curValidFrom = DateTimeHelper.StringToDate(this.props.data[0].ValidFrom,false,localStorage.getItem('vas_language'));
            curFrom = moment([curValidFrom.year(),curValidFrom.month(),curValidFrom.date()]).format('YYYY-MM-DD T 00:00:00');
          }
        }
        
        let curTo = null;
        if(this.props.data[0].ValidTo){
          if (this.props.data[0].ValidTo.length > 0){
            let curValidTo = DateTimeHelper.StringToDate(this.props.data[0].ValidTo,false,localStorage.getItem('vas_language'));
            curTo = moment([curValidTo.year(),curValidTo.month(),curValidTo.date()]).format('YYYY-MM-DD T 00:00:00');
          }
        }
                
        this.PaymentsModel.PaymentOption = this.props.data[0];
        this.PaymentsModel.PaymentOption.ValidFrom = curFrom;
        this.PaymentsModel.PaymentOption.ValidTo = curTo;
        this.PaymentsModel.PaymentOption.Id = this.props.Id;
        this.PaymentsModel.PaymentOption.IsDefaultPaymentMethod = newValue;

        this.PaymentsModel.CustomerId = this.props.CustomerId;

        this.PaymentsModel.SetStandartPaymentsOption();
      }
    }

    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');
  
      if(kontrastNumber == "true"){
        $('.textfieldDisabled, .greenBackgroundColor').attr('style', 'border-bottom: 1px dotted #1d5c87; width: 345px;'); 
      }
    }

    FontSizeClick(){
      var schriftgröße = localStorage.getItem('Schriftgröße');

      //Schriftgröße bei Klick in 2er Schritten erhöhen

        if(schriftgröße != null){
            
              switch(schriftgröße){
                case "0":
                      $("#root").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".footer").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_32").addClass("Schriftgröße_33");
    
                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                      $('#tabContent').removeClass("TabContentPaddingLeft80").addClass("TabContentPaddingLeft100");
                      $('#btoChoose').removeClass("btoChooseWidth120_80").addClass("btoChooseWidth140_100");
                      $('.ItemData').removeClass("ItemDataWidth250").addClass("ItemDataWidth270");
                      $('.ItemContracts').removeClass('width160').addClass('width160');
                      $('.ItemNewContract').removeClass('width230').addClass('width240');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_22").addClass("Schriftgröße_23");

                      $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL10");
                      $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL45").addClass("tableHeaderPaddingL55");
                      $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL10").addClass("tableHeaderPaddingL25");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_26").addClass("Schriftgröße_28");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('.StepperLabel').removeClass("Schriftgröße_22").addClass("Schriftgröße_23");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#From, #To').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('.termsOfUsage').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#btoChooseDocument').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#Payment_ButtonBack').removeClass('marginTop_20').addClass('marginTop_25');

                      $('#MenuItem_Download_CSV').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR').addClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");
                break;
                case "1":

                      $("#root").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".footer").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_33").addClass("Schriftgröße_28");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                      $('#tabContent').removeClass("TabContentPaddingLeft100").addClass("TabContentPaddingLeft1");
                      $('#btoChoose').removeClass("btoChooseWidth140_100").addClass("btoChooseWidth100_0");
                      $('.ItemData').removeClass("ItemDataWidth270").addClass("ItemDataWidth190");
                      $('.ItemContracts').removeClass('width160').addClass('width110');
                      $('.ItemNewContract').removeClass('width240').addClass('width210');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_23").addClass("Schriftgröße_18");

                      $('html body div#root.Schriftgröße_16 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft1 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL10");
                      $('html body div#root.Schriftgröße_16 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft1 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL55").addClass("tableHeaderPaddingL25");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_28").addClass("Schriftgröße_18");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('.StepperLabel').removeClass("Schriftgröße_23").addClass("Schriftgröße_18");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $('#From, #To').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('.termsOfUsage').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#btoChooseDocument').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#Payment_ButtonBack').removeClass('marginTop_25');

                      $('#MenuItem_Download_CSV').removeClass("downloadCsvPadding_1102").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_22").addClass("Schriftgröße_17");

                break;
                case "2":
                      $("#root").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".footer").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_28").addClass("Schriftgröße_29");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#tabContent').removeClass("TabContentPaddingLeft1").addClass("TabContentPaddingLeft20");
                      $('#btoChoose').removeClass("btoChooseWidth100_0").addClass("btoChooseWidth100_20");
                      $('.ItemData').removeClass("ItemDataWidth190").addClass("ItemDataWidth210");
                      $('.customerCardSubTitle').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_18").addClass("Schriftgröße_20");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('.StepperLabel').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $('#From, #To').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('.termsOfUsage').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $('#btoChooseDocument').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#Payment_ButtonBack').addClass('marginTop_5');

                      $('#MenuItem_Download_CSV').removeClass("Schriftgröße_14").addClass("Schriftgröße_15").addClass("downloadCsvPadding_1106");

                      $('.ItemContracts').removeClass('width110').addClass('width120');

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                break;
                case "3":
                      $("#root").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $(".footer").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_5").addClass("Schriftgröße_16");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_29").addClass("Schriftgröße_30");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#tabContent').removeClass("TabContentPaddingLeft20").addClass("TabContentPaddingLeft40");
                      $('#btoChoose').removeClass("btoChooseWidth100_20").addClass("btoChooseWidth100_40");
                      $('.ItemData').removeClass("ItemDataWidth210").addClass("ItemDataWidth210");
                      $('.ItemContracts').removeClass('width120').addClass('width140');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                      $('html body div#root.Schriftgröße_18 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft40 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL25").addClass("tableHeaderPaddingL45");
                      $('html body div#root.Schriftgröße_18 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft40 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL25").addClass("tableHeaderPaddingL10");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_20").addClass("Schriftgröße_22");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('.StepperLabel').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('#From, #To').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('.termsOfUsage').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('#btoChooseDocument').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#Payment_ButtonBack').removeClass('marginTop_5').addClass('marginTop_10');

                      $('#MenuItem_Download_CSV').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                break;
                case "4":
                      $("#root").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".footer").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_30").addClass("Schriftgröße_31");
    
                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#tabContent').removeClass("TabContentPaddingLeft40").addClass("TabContentPaddingLeft60");
                      $('#btoChoose').removeClass("btoChooseWidth100_40").addClass("btoChooseWidth100_60");
                      $('.ItemData').removeClass("ItemDataWidth210").addClass("ItemDataWidth230");
                      $('.ItemContracts').removeClass('width140').addClass('width140');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_22").addClass("Schriftgröße_24");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('.StepperLabel').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $('#From, #To').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('.termsOfUsage').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $('#btoChooseDocument').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#Payment_ButtonBack').removeClass('marginTop_10').addClass('marginTop_15');

                      $('#MenuItem_Download_CSV').removeClass("downloadCsvPadding_1106").removeClass("Schriftgröße_16").addClass("Schriftgröße_17").addClass("downloadCsvPadding_1104");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').addClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                break;
                case "5":
                  $("#root").removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".footer").removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_31").addClass("Schriftgröße_32");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                      $('#tabContent').removeClass("TabContentPaddingLeft60").addClass("TabContentPaddingLeft80");
                      $('#btoChoose').removeClass("btoChooseWidth100_60").addClass("btoChooseWidth120_80");
                      $('.ItemData').removeClass("ItemDataWidth230").addClass("ItemDataWidth250");
                      $('.ItemContracts').removeClass('width140').addClass('width160');
                      $('.ItemNewContract').removeClass('width210').addClass('width230');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_24").addClass("Schriftgröße_26");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('.StepperLabel').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('#From, #To').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('.termsOfUsage').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('#btoChooseDocument').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#Payment_ButtonBack').removeClass('marginTop_15').addClass('marginTop_20');

                      $('#MenuItem_Download_CSV').removeClass("downloadCsvPadding_1104").removeClass("Schriftgröße_17").addClass("Schriftgröße_18").addClass("downloadCsvPadding_1102");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR').addClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                break;
              }
        }
    }

    render()
    {   
        return (<div className={""}>
          <table>
            <tbody>
              <tr><td
                colSpan={2}
                className={"customerCardSubTitle"}><b>{Vas.Resources.Labels["MethodOfPaymentCustomer"]}</b></td></tr>
              <tr>
                <td colSpan={2}><TextField
                  AppURL={Vas.ApplicationUrl}
                  ref={"nameOfBank"}
                  Width={345}
                  Id="nameOfBank"
                  Editable={false}
                  Label={Vas.Resources.Labels["NameOfBank"]}
                  Value={this.props.data[0].BankName} /></td>
              </tr>
              <tr>
                <td colSpan={2} ><TextField
                  AppURL={Vas.ApplicationUrl}
                  ref={"depositor"}
                  Width={345}
                  Id="depositor"
                  Label={Vas.Resources.Labels["Depositor"]}
                  Value={this.props.data[0].AccountOwner}
                  Editable={false} /></td>
              </tr>
              <tr>
                <td colSpan={2}><TextField
                  AppURL={Vas.ApplicationUrl}
                  Width={345}
                  ref={"iban"}
                  Id="iban"
                  Editable={false}
                  Label={Vas.Resources.Labels["Iban"]}
                  Value={this.props.data[0].Iban} /> </td>
              </tr>
              <tr>
                <td colSpan={2}><TextField
                  AppURL={Vas.ApplicationUrl}
                  Width={345}
                  ref={"bic"}
                  Id="bic"
                  Editable={false}
                  Label={Vas.Resources.Labels["Bic"]}
                  Value={this.props.data[0].Bic} /> </td>
              </tr>
              <tr>
                <td id={"PaymentDetailsValidFrom"}><TextField
                  AppURL={Vas.ApplicationUrl}
                  ref={"validFrom"}
                  Width={170}
                  Id="validFrom"
                  Editable={false}
                  Label={Vas.Resources.Labels["ValidFrom"]}
                  Value={this.from} /></td>
                <td id={"PaymentDetailsValidTo"}><TextField
                  AppURL={Vas.ApplicationUrl}
                  ref={"validTo"}
                  Width={170}
                  Id="validTo"
                  Editable={false}
                  Label={Vas.Resources.Labels["ValidTo"]}
                  Value={this.to} /></td>
              </tr>
              <tr>
                <td id={"PaymentDetailsDefaultPayment"}><br />{Vas.Resources.Labels["DefaultMethodOfPayment"]}:</td>
                <td id={"PaymentDetailsDefaultPaymentCheckBox"} className={"PaymentDetailsDefaultPaymentCheckBox"}>
                  <Checkbox
                    Id={"Pay"}
                    ref={"defaultPayment"}
                    onClick={()=>{this.SetDefaultPayment();}} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>);
    }
}
export default CustomerContractDetails;
